import { z } from "zod";

export const GeneralidadesSchema = z.object({
  tipoSolicitud: z.enum(["vinculacion", "actualizacion"], {
    required_error: "Seleccione el tipo de solicitud",
  }),
  tipoTercero: z.enum(
    ["cliente", "proveedor", "contratista", "accionista", "miembro_junta"],
    {
      required_error: "Seleccione el tipo de tercero",
    }
  ),
});

export type GeneralidadesFormData = z.infer<typeof GeneralidadesSchema>;
